import { ExperienceApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useExperienceAPI(): ExperienceApi {
  return new ExperienceApi(apiConfig);
}
